export const initialFormValues = {
  accountCode: '',
  accountDescription: '',
  depreciationValue: '',
  observations: ''
}
